<template class="full-heigth">
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="travel-app-container" style="position: relative; height: 100%">
    <data-table />
  </div>
</template>

<script>
import dataTable from './components/tourGroupDataTable.vue'
export default {
  name: 'Travel',
  components: { dataTable },
  data() {
    return {
      list: null,
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {},
    handleDownload() {},
  },
}
</script>

<style>
.full-heigth {
  position: relative;
  height: 100%;
}
</style>
